export * from './svg-gradients';

//# sourceMappingURL=index.js.map